import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { AUTH_TOKEN } from "constants/AuthConstant";
import MasterCustomerService from "services/Setup/Master/masterCustomerService";
import { notification } from "antd";

export const initialState = {
  loading: false,
  message: "",
  showMessage: false,
  redirect: "",
  token: localStorage.getItem(AUTH_TOKEN) || null,
  result: {},
  personalCustomerTypeCodeList: [{ code: "", name: "" }],
  genderCustomerCodeList: [{ code: "", name: "" }],
  maritalStatusCodeList: [{ code: "", name: "" }],
  religionCodeList: [{ code: "", name: "" }],
  nationalityCodeList: [{ code: "", name: "" }],
  countryCodeList: [{ code: "", name: "" }],
  educationCodeList: [{ code: "", name: "" }],
  homeStatusCodeList: [{ code: "", name: "" }],
  sptTahunanCodeList: {},
  typeOfWorkCodeList: [{ code: "", name: "" }],
  workCodeList: {},
  businessEntityCodeList: {},
  economySectorCodeList: {},
  workFieldCodeList: {},
  jobTitleCodeList: {},
  employeeStatusCodeList: {},
  companyCategoryCodeList: {},
  officeConditionCodeList: {},
  rltnshpWithReporterCodeList: {},
  sourceIncomeCodeList: {},
  propertySeparationAgreementCodeList: {},
  masterBankCodeList: {},
  masterCreditCodeList: {},
  iDTypeCodeList: {},
  jobStatusCodeList: {},
  rltnshpWithCustomerCodeList: {},
  institutionTypeCodeList: {},
  loanTypeCodeList: {},
  thrdPrtyGrpCodeList: {},
  companyStatusCodeList: {},
  officeStatusCodeList: {},
  legalDocumentCodeList: {},
  jobPositionCodeList: {},
  businessRiskCodeList: {},
  envSocialRiskCodeList: {},
  bankAccountTypeList: {},
};

export const getPersonalCustomerTypeCodeList = createAsyncThunk(
  "masterCustomer/getPersonalCustomerTypeCodeList",
  async (data, { rejectWithValue }) => {
    try {
      const response =
        await MasterCustomerService.getPersonalCustomerTypeCodeList();
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const getGenderCustomerCodeList = createAsyncThunk(
  "masterCustomer/getGenderCustomerCodeList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await MasterCustomerService.getGenderCustomerCodeList();
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const getMaritalStatusCodeList = createAsyncThunk(
  "masterCustomer/getMaritalStatusCodeList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await MasterCustomerService.getMaritalStatusCodeList();
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const getReligionCodeList = createAsyncThunk(
  "masterCustomer/getReligionCodeList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await MasterCustomerService.getReligionCodeList();
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const getNationalityCodeList = createAsyncThunk(
  "masterCustomer/getNationalityCodeList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await MasterCustomerService.getNationalityCodeList();
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const getCountryCodeList = createAsyncThunk(
  "masterCustomer/getCountryCodeList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await MasterCustomerService.getCountryCodeList();
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const getEducationCodeList = createAsyncThunk(
  "masterCustomer/getEducationCodeList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await MasterCustomerService.getEducationCodeList();
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const getHomeStatusCodeList = createAsyncThunk(
  "masterCustomer/getHomeStatusCodeList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await MasterCustomerService.getHomeStatusCodeList();
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const getSptTahunanCodeList = createAsyncThunk(
  "masterCustomer/getSptTahunanCodeList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await MasterCustomerService.getSptTahunanCodeList();
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const getTypeOfWorkCodeList = createAsyncThunk(
  "masterCustomer/getTypeOfWorkCodeList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await MasterCustomerService.getTypeOfWorkCodeList();
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const getWorkCodeList = createAsyncThunk(
  "masterCustomer/getWorkCodeList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await MasterCustomerService.getWorkCodeList();
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const getBusinessEntityCodeList = createAsyncThunk(
  "masterCustomer/getBusinessEntityCodeList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await MasterCustomerService.getBusinessEntityCodeList();
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const getEconomySectorCodeList = createAsyncThunk(
  "masterCustomer/getEconomySectorCodeList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await MasterCustomerService.getEconomySectorCodeList(
        data
      );
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const getWorkFieldCodeList = createAsyncThunk(
  "masterCustomer/getWorkFieldCodeList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await MasterCustomerService.getWorkFieldCodeList(data);
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const getJobTitleCodeList = createAsyncThunk(
  "masterCustomer/getJobTitleCodeList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await MasterCustomerService.getJobTitleCodeList();
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const getEmployeeStatusCodeList = createAsyncThunk(
  "masterCustomer/getEmployeeStatusCodeList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await MasterCustomerService.getEmployeeStatusCodeList();
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const getCompanyCategoryCodeList = createAsyncThunk(
  "masterCustomer/getCompanyCategoryCodeList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await MasterCustomerService.getCompanyCategoryCodeList();
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const getOfficeConditionCodeList = createAsyncThunk(
  "masterCustomer/getOfficeConditionCodeList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await MasterCustomerService.getOfficeConditionCodeList();
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const getRltnshpWithReporterCodeList = createAsyncThunk(
  "masterCustomer/getRltnshpWithReporterCodeList",
  async (data, { rejectWithValue }) => {
    try {
      const response =
        await MasterCustomerService.getRltnshpWithReporterCodeList(data);
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const getSourceIncomeCodeList = createAsyncThunk(
  "masterCustomer/getSourceIncomeCodeList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await MasterCustomerService.getSourceIncomeCodeList();
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const getPropertySeparationAgreementCodeList = createAsyncThunk(
  "masterCustomer/getPropertySeparationAgreementCodeList",
  async (data, { rejectWithValue }) => {
    try {
      const response =
        await MasterCustomerService.getPropertySeparationAgreementCodeList();
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const getMasterBankCodeList = createAsyncThunk(
  "masterCustomer/getMasterBankCodeList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await MasterCustomerService.getMasterBankCodeList();
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const getMasterCreditCodeList = createAsyncThunk(
  "masterCustomer/getMasterCreditCodeList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await MasterCustomerService.getMasterCreditCodeList();
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const getIDTypeCodeList = createAsyncThunk(
  "masterCustomer/getIDTypeCodeList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await MasterCustomerService.getIDTypeCodeList();
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const getJobStatusCodeList = createAsyncThunk(
  "masterCustomer/getJobStatusCodeList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await MasterCustomerService.getJobStatusCodeList();
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const getRltnshpWithCustomerCodeList = createAsyncThunk(
  "masterCustomer/getRltnshpWithCustomerCodeList",
  async (data, { rejectWithValue }) => {
    try {
      const response =
        await MasterCustomerService.getRltnshpWithCustomerCodeList();
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const getInstitutionTypeCodeList = createAsyncThunk(
  "masterCustomer/getInstitutionTypeCodeList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await MasterCustomerService.getInstitutionTypeCodeList();
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const getLoanTypeCodeList = createAsyncThunk(
  "masterCustomer/getLoanTypeCodeList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await MasterCustomerService.getLoanTypeCodeList();
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const getThrdPrtyGrpCodeList = createAsyncThunk(
  "masterCustomer/getThrdPrtyGrpCodeList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await MasterCustomerService.getThrdPrtyGrpCodeList(data);
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const getCompanyStatusCodeList = createAsyncThunk(
  "masterCustomer/getCompanyStatusCodeList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await MasterCustomerService.getCompanyStatusCodeList();
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const getOfficeStatusCodeList = createAsyncThunk(
  "masterCustomer/getOfficeStatusCodeList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await MasterCustomerService.getOfficeStatusCodeList();
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const getLegalDocumentCodeList = createAsyncThunk(
  "masterCustomer/getLegalDocumentCodeList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await MasterCustomerService.getLegalDocumentCodeList();
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const getJobPositionCodeList = createAsyncThunk(
  "masterCustomer/getJobPositionCodeList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await MasterCustomerService.getJobPositionCodeList();
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const getBusinessRiskCodeList = createAsyncThunk(
  "masterCustomer/getBusinessRiskCodeList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await MasterCustomerService.getBusinessRiskCodeList();
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const getEnvSocialRiskCodeList = createAsyncThunk(
  "masterCustomer/getEnvSocialRiskCodeList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await MasterCustomerService.getEnvSocialRiskCodeList();
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const getBankAccountTypeList = createAsyncThunk(
  "masterCustomer/getBankAccountTypeList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await MasterCustomerService.getBankAccountTypeList();
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const masterCustomer = createSlice({
  name: "masterCustomer",
  initialState,
  reducer: {
    showNotification: (state, action) => {
      state.message = action.payload;
      state.showMessage = true;
      state.loading = false;
    },
    hideNotification: (state) => {
      state.message = "";
      state.showMessage = false;
    },
    showLoading: (state) => {
      state.loading = true;
    },
  },

  extraReducers: (builder) => {
    builder
      //get list personal customer type
      .addCase(getPersonalCustomerTypeCodeList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getPersonalCustomerTypeCodeList.fulfilled, (state, action) => {
        state.loading = false;
        state.personalCustomerTypeCodeList = action.payload;
      })
      .addCase(getPersonalCustomerTypeCodeList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //get list gender customer
      .addCase(getGenderCustomerCodeList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getGenderCustomerCodeList.fulfilled, (state, action) => {
        state.loading = false;
        state.genderCustomerCodeList = action.payload;
      })
      .addCase(getGenderCustomerCodeList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //get list marital status
      .addCase(getMaritalStatusCodeList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getMaritalStatusCodeList.fulfilled, (state, action) => {
        state.loading = false;
        state.maritalStatusCodeList = action.payload;
      })
      .addCase(getMaritalStatusCodeList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //get list religion
      .addCase(getReligionCodeList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getReligionCodeList.fulfilled, (state, action) => {
        state.loading = false;
        state.religionCodeList = action.payload;
      })
      .addCase(getReligionCodeList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //get list nationality
      .addCase(getNationalityCodeList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getNationalityCodeList.fulfilled, (state, action) => {
        state.loading = false;
        state.nationalityCodeList = action.payload;
      })
      .addCase(getNationalityCodeList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //get list country
      .addCase(getCountryCodeList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getCountryCodeList.fulfilled, (state, action) => {
        state.loading = false;
        state.countryCodeList = action.payload;
      })
      .addCase(getCountryCodeList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //get list education
      .addCase(getEducationCodeList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getEducationCodeList.fulfilled, (state, action) => {
        state.loading = false;
        state.educationCodeList = action.payload;
      })
      .addCase(getEducationCodeList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //get list home status
      .addCase(getHomeStatusCodeList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getHomeStatusCodeList.fulfilled, (state, action) => {
        state.loading = false;
        state.homeStatusCodeList = action.payload;
      })
      .addCase(getHomeStatusCodeList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //get list spt tahunan
      .addCase(getSptTahunanCodeList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getSptTahunanCodeList.fulfilled, (state, action) => {
        state.loading = false;
        state.sptTahunanCodeList = action.payload;
      })
      .addCase(getSptTahunanCodeList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //get list type of work
      .addCase(getTypeOfWorkCodeList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getTypeOfWorkCodeList.fulfilled, (state, action) => {
        state.loading = false;
        state.typeOfWorkCodeList = action.payload;
      })
      .addCase(getTypeOfWorkCodeList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //get list work code
      .addCase(getWorkCodeList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getWorkCodeList.fulfilled, (state, action) => {
        state.loading = false;
        state.workCodeList = action.payload;
      })
      .addCase(getWorkCodeList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //get list business entity
      .addCase(getBusinessEntityCodeList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getBusinessEntityCodeList.fulfilled, (state, action) => {
        state.loading = false;
        state.businessEntityCodeList = action.payload;
      })
      .addCase(getBusinessEntityCodeList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //get list economy sector
      .addCase(getEconomySectorCodeList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getEconomySectorCodeList.fulfilled, (state, action) => {
        state.loading = false;
        state.economySectorCodeList = action.payload;
        state.getCount = action.payload.data.count;
      })
      .addCase(getEconomySectorCodeList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;

        notification.error({
          message: "Data Not Found",
          description:
            "The data you are looking for is not available. Please check again.",
          duration: 3,
        });
      })
      //get list work field
      .addCase(getWorkFieldCodeList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getWorkFieldCodeList.fulfilled, (state, action) => {
        state.loading = false;
        state.workFieldCodeList = action.payload;
      })
      .addCase(getWorkFieldCodeList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //get list job title
      .addCase(getJobTitleCodeList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getJobTitleCodeList.fulfilled, (state, action) => {
        state.loading = false;
        state.jobTitleCodeList = action.payload;
      })
      .addCase(getJobTitleCodeList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //get list employee status
      .addCase(getEmployeeStatusCodeList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getEmployeeStatusCodeList.fulfilled, (state, action) => {
        state.loading = false;
        state.employeeStatusCodeList = action.payload;
      })
      .addCase(getEmployeeStatusCodeList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //get list company category
      .addCase(getCompanyCategoryCodeList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getCompanyCategoryCodeList.fulfilled, (state, action) => {
        state.loading = false;
        state.companyCategoryCodeList = action.payload;
      })
      .addCase(getCompanyCategoryCodeList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //get list office condition
      .addCase(getOfficeConditionCodeList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getOfficeConditionCodeList.fulfilled, (state, action) => {
        state.loading = false;
        state.officeConditionCodeList = action.payload;
      })
      .addCase(getOfficeConditionCodeList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //get list relationship with reporter
      .addCase(getRltnshpWithReporterCodeList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getRltnshpWithReporterCodeList.fulfilled, (state, action) => {
        state.loading = false;
        state.rltnshpWithReporterCodeList = action.payload;
        state.getCount = action.payload.data.count;
      })
      .addCase(getRltnshpWithReporterCodeList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;

        notification.error({
          message: "Data Not Found",
          description:
            "The data you are looking for is not available. Please check again.",
          duration: 3,
        });
      })

      //get list source income
      .addCase(getSourceIncomeCodeList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getSourceIncomeCodeList.fulfilled, (state, action) => {
        state.loading = false;
        state.sourceIncomeCodeList = action.payload;
      })
      .addCase(getSourceIncomeCodeList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //get list source income
      .addCase(getPropertySeparationAgreementCodeList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(
        getPropertySeparationAgreementCodeList.fulfilled,
        (state, action) => {
          state.loading = false;
          state.propertySeparationAgreementCodeList = action.payload;
        }
      )
      .addCase(
        getPropertySeparationAgreementCodeList.rejected,
        (state, action) => {
          state.loading = false;
          state.result = action.payload;
          state.showMessage = true;
        }
      )

      //get list master bank
      .addCase(getMasterBankCodeList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getMasterBankCodeList.fulfilled, (state, action) => {
        state.loading = false;
        state.masterBankCodeList = action.payload;
      })
      .addCase(getMasterBankCodeList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //get list master bank kredit
      .addCase(getMasterCreditCodeList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getMasterCreditCodeList.fulfilled, (state, action) => {
        state.loading = false;
        state.masterCreditCodeList = action.payload;
      })
      .addCase(getMasterCreditCodeList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //get list id type
      .addCase(getIDTypeCodeList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getIDTypeCodeList.fulfilled, (state, action) => {
        state.loading = false;
        state.iDTypeCodeList = action.payload;
      })
      .addCase(getIDTypeCodeList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //get list job status
      .addCase(getJobStatusCodeList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getJobStatusCodeList.fulfilled, (state, action) => {
        state.loading = false;
        state.jobStatusCodeList = action.payload;
      })
      .addCase(getJobStatusCodeList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //get list relationship with customer
      .addCase(getRltnshpWithCustomerCodeList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getRltnshpWithCustomerCodeList.fulfilled, (state, action) => {
        state.loading = false;
        state.rltnshpWithCustomerCodeList = action.payload;
      })
      .addCase(getRltnshpWithCustomerCodeList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //get list Institution Type
      .addCase(getInstitutionTypeCodeList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getInstitutionTypeCodeList.fulfilled, (state, action) => {
        state.loading = false;
        state.institutionTypeCodeList = action.payload;
      })
      .addCase(getInstitutionTypeCodeList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //get list Loan Type
      .addCase(getLoanTypeCodeList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getLoanTypeCodeList.fulfilled, (state, action) => {
        state.loading = false;
        state.loanTypeCodeList = action.payload;
      })
      .addCase(getLoanTypeCodeList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //get list Third Party Group
      .addCase(getThrdPrtyGrpCodeList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getThrdPrtyGrpCodeList.fulfilled, (state, action) => {
        state.loading = false;
        state.thrdPrtyGrpCodeList = action.payload.data;
        state.getCount = action.payload.data.count;
      })
      .addCase(getThrdPrtyGrpCodeList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
        notification.error({
          message: "Data Not Found",
          description:
            "The data you are looking for is not available. Please check again.",
          duration: 3,
        });
      })

      //get list Company Status
      .addCase(getCompanyStatusCodeList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getCompanyStatusCodeList.fulfilled, (state, action) => {
        state.loading = false;
        state.companyStatusCodeList = action.payload;
      })
      .addCase(getCompanyStatusCodeList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //get list Office Status
      .addCase(getOfficeStatusCodeList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getOfficeStatusCodeList.fulfilled, (state, action) => {
        state.loading = false;
        state.officeStatusCodeList = action.payload;
      })
      .addCase(getOfficeStatusCodeList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //get list Legal Document
      .addCase(getLegalDocumentCodeList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getLegalDocumentCodeList.fulfilled, (state, action) => {
        state.loading = false;
        state.legalDocumentCodeList = action.payload;
      })
      .addCase(getLegalDocumentCodeList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //get list Job Position
      .addCase(getJobPositionCodeList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getJobPositionCodeList.fulfilled, (state, action) => {
        state.loading = false;
        state.jobPositionCodeList = action.payload;
      })
      .addCase(getJobPositionCodeList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //get list Business Risk
      .addCase(getBusinessRiskCodeList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getBusinessRiskCodeList.fulfilled, (state, action) => {
        state.loading = false;
        state.businessRiskCodeList = action.payload;
      })
      .addCase(getBusinessRiskCodeList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //get list Env Social Risk
      .addCase(getEnvSocialRiskCodeList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getEnvSocialRiskCodeList.fulfilled, (state, action) => {
        state.loading = false;
        state.envSocialRiskCodeList = action.payload;
      })
      .addCase(getEnvSocialRiskCodeList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //get list bank account type
      .addCase(getBankAccountTypeList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getBankAccountTypeList.fulfilled, (state, action) => {
        state.loading = false;
        state.bankAccountTypeList = action.payload;
      })
      .addCase(getBankAccountTypeList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      });
  },
});

export const { showNotification, hideNotification, showLoading } =
  masterCustomer.actions;

export default masterCustomer.reducer;
